import constants, { DATA_TYPES } from './CommonConstants';
import { PIPELINE_TYPE } from './PipelineConstatnts';

export const SYSTEM_FIELDS = {
  HEALTH: 'system:health',
  PULSE: 'system:pulse',
  LIFECYCLE_STAGE: 'system:lifecycleStageId',
  OWNER: 'system:owners',
  EMAIL: 'system:email',
  PIPELINE_STATUS: 'system:pipelineStatus',
  EXTERNAL_ID: 'system:externalId',
  VELARIS_ID: 'system:velarisId',
  NPS: 'system:nps',
  LAST_NPS: 'system:lastNps',
  NPS_CATEGORY: 'system:npsCategory',
  CSAT: 'system:csat',
  LAST_CSAT: 'system:lastCsat',
  CSAT_CATEGORY: 'system:csatCategory',
  PORTAL_ACCESS: 'system:portalAccess',
  CHURN_DATE: 'system:churnDate',
  CHURN_REASON: 'system:churnReason',
  CHURN_COMMENT: 'system:churnComments',
  PRIMARY_OWNER: 'system:primaryOwner',
  DOMAIN: 'system:domain',
};

export const ID_SYSTEM_FIELD_MAPPING = {
  [-1]: SYSTEM_FIELDS.HEALTH,
  [-2]: SYSTEM_FIELDS.PULSE,
  [-3]: SYSTEM_FIELDS.LIFECYCLE_STAGE,
  [-4]: SYSTEM_FIELDS.OWNER,
  [-5]: SYSTEM_FIELDS.EMAIL,
  [-6]: SYSTEM_FIELDS.PIPELINE_STATUS,
  [-7]: SYSTEM_FIELDS.EXTERNAL_ID,
  [-8]: SYSTEM_FIELDS.VELARIS_ID,
  [-9]: SYSTEM_FIELDS.NPS,
  [-10]: SYSTEM_FIELDS.LAST_NPS,
  [-11]: SYSTEM_FIELDS.PORTAL_ACCESS,
  [-12]: SYSTEM_FIELDS.CHURN_DATE,
  [-13]: SYSTEM_FIELDS.CHURN_REASON,
  [-14]: SYSTEM_FIELDS.CHURN_COMMENT,
  [-15]: SYSTEM_FIELDS.DOMAIN,
  [-16]: SYSTEM_FIELDS.CSAT,
  [-17]: SYSTEM_FIELDS.LAST_CSAT,
};

export const SYSTEM_FIELD_DATA = {
  [SYSTEM_FIELDS.HEALTH]: {
    systemFieldId: -1,
    name: SYSTEM_FIELDS.HEALTH,
    displayName: 'Health',
    dataType: DATA_TYPES.number,
    required: true,
    isEditable: false,
    isUploadable: false, // STRICTLY FALSE IF isEditable =FALSE
  },
  [SYSTEM_FIELDS.PULSE]: {
    systemFieldId: -2,
    name: SYSTEM_FIELDS.PULSE,
    displayName: 'Pulse',
    dataType: DATA_TYPES.pulse,
    required: true,
    isEditable: true,
    isUploadable: false, // Pulse cannot be a part of entity
  },
  [SYSTEM_FIELDS.LIFECYCLE_STAGE]: {
    systemFieldId: -3,
    name: SYSTEM_FIELDS.LIFECYCLE_STAGE,
    displayName: 'Lifecycle Stage',
    dataType: DATA_TYPES.lifecycleStage,
    required: true,
    isEditable: true,
    isUploadable: true, // STRICTLY FALSE IF isEditable =FALSE
  },
  [SYSTEM_FIELDS.OWNER]: {
    systemFieldId: -4,
    name: SYSTEM_FIELDS.OWNER,
    displayName: 'Owner',
    dataType: DATA_TYPES.owner,
    required: true,
    isEditable: true,
    isUploadable: true, // STRICTLY FALSE IF isEditable =FALSE
  },
  [SYSTEM_FIELDS.EMAIL]: {
    systemFieldId: -5,
    name: SYSTEM_FIELDS.EMAIL,
    displayName: 'Email',
    dataType: DATA_TYPES.email,
    required: true,
    isEditable: true,
    isUploadable: false, // STRICTLY FALSE IF isEditable =FALSE
  },
  [SYSTEM_FIELDS.PIPELINE_STATUS]: {
    systemFieldId: -6,
    name: SYSTEM_FIELDS.PIPELINE_STATUS,
    displayName: 'Lifecycle Stage',
    dataType: DATA_TYPES.pipelineStatus,
    required: true,
    isEditable: true,
    isUploadable: false, // STRICTLY FALSE IF isEditable =FALSE
  },
  [SYSTEM_FIELDS.EXTERNAL_ID]: {
    systemFieldId: -7,
    name: SYSTEM_FIELDS.EXTERNAL_ID,
    displayName: 'External ID',
    dataType: DATA_TYPES.string,
    required: false,
    isEditable: false,
    isUploadable: false, // STRICTLY FALSE IF isEditable = FALSE
  },
  [SYSTEM_FIELDS.VELARIS_ID]: {
    systemFieldId: -8,
    name: SYSTEM_FIELDS.VELARIS_ID,
    displayName: 'Velaris ID',
    dataType: DATA_TYPES.mandatoryNumber,
    required: false,
    isEditable: false,
    isUploadable: false, // STRICTLY FALSE IF isEditable = FALSE
  },
  [SYSTEM_FIELDS.NPS]: {
    systemFieldId: -9,
    name: SYSTEM_FIELDS.NPS,
    displayName: 'NPS',
    dataType: DATA_TYPES.number,
    required: false,
    isEditable: false,
    isUploadable: false,
  },
  [SYSTEM_FIELDS.LAST_NPS]: {
    systemFieldId: -10,
    name: SYSTEM_FIELDS.LAST_NPS,
    displayName: 'Last NPS Rating',
    dataType: DATA_TYPES.number,
    required: false,
    isEditable: false,
    isUploadable: false,
  },
  [SYSTEM_FIELDS.PORTAL_ACCESS]: {
    systemFieldId: -11,
    name: SYSTEM_FIELDS.PORTAL_ACCESS,
    displayName: 'Connect App status',
    dataType: DATA_TYPES.boolean,
    required: false,
    isEditable: true,
    isUploadable: false,
  },
  [SYSTEM_FIELDS.CHURN_DATE]: {
    systemFieldId: -12,
    name: SYSTEM_FIELDS.CHURN_DATE,
    displayName: 'Churn Date',
    dataType: DATA_TYPES.date,
    required: true,
    isEditable: true,
    isUploadable: false,
  },
  [SYSTEM_FIELDS.CHURN_REASON]: {
    systemFieldId: -13,
    name: SYSTEM_FIELDS.CHURN_REASON,
    displayName: 'Churn Reason',
    dataType: DATA_TYPES.churnReason,
    required: false,
    isEditable: true,
    isUploadable: false,
  },
  [SYSTEM_FIELDS.CHURN_COMMENT]: {
    systemFieldId: -14,
    name: SYSTEM_FIELDS.CHURN_COMMENT,
    displayName: 'Churn Comment',
    dataType: DATA_TYPES.longText,
    required: false,
    isEditable: true,
    isUploadable: false,
    options: {
      maxLength: 500,
      maxCellTextLimit: 100,
    },
  },
  [SYSTEM_FIELDS.DOMAIN]: {
    systemFieldId: -15,
    name: SYSTEM_FIELDS.DOMAIN,
    displayName: 'Domain',
    dataType: DATA_TYPES.domain,
    required: false,
    isEditable: true,
    isUploadable: true,
  },
  [SYSTEM_FIELDS.CSAT]: {
    systemFieldId: -16,
    name: SYSTEM_FIELDS.CSAT,
    displayName: 'CSAT',
    dataType: DATA_TYPES.number,
    required: false,
    isEditable: false,
    isUploadable: false,
  },
  [SYSTEM_FIELDS.LAST_CSAT]: {
    systemFieldId: -17,
    name: SYSTEM_FIELDS.LAST_CSAT,
    displayName: 'Last CSAT Rating',
    dataType: DATA_TYPES.number,
    required: false,
    isEditable: false,
    isUploadable: false,
  },
};

export const PIPELINE_DATA = {
  [SYSTEM_FIELDS.PIPELINE_STATUS]: {
    name: SYSTEM_FIELDS.PIPELINE_STATUS,
    displayName: 'Pipeline Closed Lost',
    dataType: DATA_TYPES.pipelineStatus,
  },
  [SYSTEM_FIELDS.PIPELINE_STATUS]: {
    name: SYSTEM_FIELDS.PIPELINE_STATUS,
    displayName: 'Pipeline Closed Won',
    dataType: DATA_TYPES.pipelineStatus,
  },
  [SYSTEM_FIELDS.PIPELINE_STATUS]: {
    name: SYSTEM_FIELDS.PIPELINE_STATUS,
    displayName: 'Pipeline Mitigated',
    dataType: DATA_TYPES.pipelineStatus,
  },
  [SYSTEM_FIELDS.PIPELINE_STATUS]: {
    name: SYSTEM_FIELDS.PIPELINE_STATUS,
    displayName: 'Pipeline Realised',
    dataType: DATA_TYPES.pipelineStatus,
  },
};
export const LEVEL_SYSTEM_FIELD_MAPPING = {
  [constants.ORGANIZATION_LEVEL]: {
    [SYSTEM_FIELDS.HEALTH]: SYSTEM_FIELD_DATA[SYSTEM_FIELDS.HEALTH],
    [SYSTEM_FIELDS.PULSE]: SYSTEM_FIELD_DATA[SYSTEM_FIELDS.PULSE],
    [SYSTEM_FIELDS.OWNER]: SYSTEM_FIELD_DATA[SYSTEM_FIELDS.OWNER],
    [SYSTEM_FIELDS.LIFECYCLE_STAGE]:
      SYSTEM_FIELD_DATA[SYSTEM_FIELDS.LIFECYCLE_STAGE],
    [SYSTEM_FIELDS.EXTERNAL_ID]: SYSTEM_FIELD_DATA[SYSTEM_FIELDS.EXTERNAL_ID],
    [SYSTEM_FIELDS.VELARIS_ID]: SYSTEM_FIELD_DATA[SYSTEM_FIELDS.VELARIS_ID],
    [SYSTEM_FIELDS.NPS]: SYSTEM_FIELD_DATA[SYSTEM_FIELDS.NPS],
    [SYSTEM_FIELDS.CSAT]: SYSTEM_FIELD_DATA[SYSTEM_FIELDS.CSAT],
    [SYSTEM_FIELDS.CHURN_DATE]: SYSTEM_FIELD_DATA[SYSTEM_FIELDS.CHURN_DATE],
    [SYSTEM_FIELDS.CHURN_REASON]: SYSTEM_FIELD_DATA[SYSTEM_FIELDS.CHURN_REASON],
    [SYSTEM_FIELDS.CHURN_COMMENT]:
      SYSTEM_FIELD_DATA[SYSTEM_FIELDS.CHURN_COMMENT],
    [SYSTEM_FIELDS.DOMAIN]: SYSTEM_FIELD_DATA[SYSTEM_FIELDS.DOMAIN],
  },
  [constants.ACCOUNT_LEVEL]: {
    [SYSTEM_FIELDS.HEALTH]: SYSTEM_FIELD_DATA[SYSTEM_FIELDS.HEALTH],
    [SYSTEM_FIELDS.PULSE]: SYSTEM_FIELD_DATA[SYSTEM_FIELDS.PULSE],
    [SYSTEM_FIELDS.OWNER]: SYSTEM_FIELD_DATA[SYSTEM_FIELDS.OWNER],
    [SYSTEM_FIELDS.LIFECYCLE_STAGE]:
      SYSTEM_FIELD_DATA[SYSTEM_FIELDS.LIFECYCLE_STAGE],
    [SYSTEM_FIELDS.EXTERNAL_ID]: SYSTEM_FIELD_DATA[SYSTEM_FIELDS.EXTERNAL_ID],
    [SYSTEM_FIELDS.VELARIS_ID]: SYSTEM_FIELD_DATA[SYSTEM_FIELDS.VELARIS_ID],
    [SYSTEM_FIELDS.NPS]: SYSTEM_FIELD_DATA[SYSTEM_FIELDS.NPS],
    [SYSTEM_FIELDS.CSAT]: SYSTEM_FIELD_DATA[SYSTEM_FIELDS.CSAT],
    [SYSTEM_FIELDS.CHURN_DATE]: SYSTEM_FIELD_DATA[SYSTEM_FIELDS.CHURN_DATE],
    [SYSTEM_FIELDS.CHURN_REASON]: SYSTEM_FIELD_DATA[SYSTEM_FIELDS.CHURN_REASON],
    [SYSTEM_FIELDS.CHURN_COMMENT]:
      SYSTEM_FIELD_DATA[SYSTEM_FIELDS.CHURN_COMMENT],
    [SYSTEM_FIELDS.DOMAIN]: SYSTEM_FIELD_DATA[SYSTEM_FIELDS.DOMAIN],
  },
  [constants.CONTACT_LEVEL]: {
    [SYSTEM_FIELDS.HEALTH]: SYSTEM_FIELD_DATA[SYSTEM_FIELDS.HEALTH],
    [SYSTEM_FIELDS.PULSE]: SYSTEM_FIELD_DATA[SYSTEM_FIELDS.PULSE],
    [SYSTEM_FIELDS.EMAIL]: SYSTEM_FIELD_DATA[SYSTEM_FIELDS.EMAIL],
    [SYSTEM_FIELDS.LIFECYCLE_STAGE]:
      SYSTEM_FIELD_DATA[SYSTEM_FIELDS.LIFECYCLE_STAGE],
    [SYSTEM_FIELDS.EXTERNAL_ID]: SYSTEM_FIELD_DATA[SYSTEM_FIELDS.EXTERNAL_ID],
    [SYSTEM_FIELDS.VELARIS_ID]: SYSTEM_FIELD_DATA[SYSTEM_FIELDS.VELARIS_ID],
    [SYSTEM_FIELDS.LAST_NPS]: SYSTEM_FIELD_DATA[SYSTEM_FIELDS.LAST_NPS],
    [SYSTEM_FIELDS.LAST_CSAT]: SYSTEM_FIELD_DATA[SYSTEM_FIELDS.LAST_CSAT],
    [SYSTEM_FIELDS.PORTAL_ACCESS]:
      SYSTEM_FIELD_DATA[SYSTEM_FIELDS.PORTAL_ACCESS],
  },
  [constants.PIPELINE_LEVEL]: {
    [SYSTEM_FIELDS.LIFECYCLE_STAGE]:
      SYSTEM_FIELD_DATA[SYSTEM_FIELDS.LIFECYCLE_STAGE],
    [SYSTEM_FIELDS.VELARIS_ID]: SYSTEM_FIELD_DATA[SYSTEM_FIELDS.VELARIS_ID],
  },
  [constants.OPPORTUNITY_LEVEL]: {
    [SYSTEM_FIELDS.LIFECYCLE_STAGE]:
      SYSTEM_FIELD_DATA[SYSTEM_FIELDS.PIPELINE_STATUS],
    [SYSTEM_FIELDS.VELARIS_ID]: SYSTEM_FIELD_DATA[SYSTEM_FIELDS.VELARIS_ID],
  },
  [constants.RISK_LEVEL]: {
    [SYSTEM_FIELDS.LIFECYCLE_STAGE]:
      SYSTEM_FIELD_DATA[SYSTEM_FIELDS.PIPELINE_STATUS],
    [SYSTEM_FIELDS.VELARIS_ID]: SYSTEM_FIELD_DATA[SYSTEM_FIELDS.VELARIS_ID],
  },
  [constants.CUSTOM_OBJECT_LEVEL]: {
    [SYSTEM_FIELDS.EXTERNAL_ID]: SYSTEM_FIELD_DATA[SYSTEM_FIELDS.EXTERNAL_ID],
    [SYSTEM_FIELDS.VELARIS_ID]: SYSTEM_FIELD_DATA[SYSTEM_FIELDS.VELARIS_ID],
  },
};

export const PIPELINES_FIELD_MAPPING = {
  [PIPELINE_TYPE.OPPORTUNITY.id]: {
    [SYSTEM_FIELDS.PIPELINE_STATUS]:
      PIPELINE_DATA[SYSTEM_FIELDS.PIPELINE_STATUS],
    [SYSTEM_FIELDS.PIPELINE_STATUS]:
      PIPELINE_DATA[SYSTEM_FIELDS.PIPELINE_STATUS],
  },
  [PIPELINE_TYPE.RISK.id]: {
    [SYSTEM_FIELDS.PIPELINE_STATUS]:
      PIPELINE_DATA[SYSTEM_FIELDS.PIPELINE_STATUS],
    [SYSTEM_FIELDS.PIPELINE_STATUS]:
      PIPELINE_DATA[SYSTEM_FIELDS.PIPELINE_STATUS],
  },
};

export const TEMPLATING_SYSTEM_FIELDS = {
  [constants.ORGANIZATION_LEVEL]: {
    about: {
      systemFieldName: 'about',
      name: 'about',
      displayName: 'About',
    },
    externalId: {
      systemFieldName: 'externalId',
      name: 'externalId',
      displayName: 'External ID',
    },
    pulse: {
      systemFieldName: 'pulse',
      name: 'pulse',
      displayName: 'Pulse',
    },
    primaryOwner: {
      systemFieldName: 'owners',
      name: 'primaryOwner',
      displayName: 'Primary Owner',
    },
    lifecycleStage: {
      systemFieldName: 'lifecycleStageId',
      name: 'lifecycleStage',
      displayName: 'Lifecycle Stage',
    },
    healthScore: {
      systemFieldName: 'healthScore',
      name: 'healthScore',
      displayName: 'Health Score',
    },
    healthStatus: {
      systemFieldName: 'healthStatus',
      name: 'healthStatus',
      displayName: 'Health Status',
    },
    // churnReason: {
    //   systemFieldName: 'churnReason',
    //   name: 'churnReason',
    //   displayName: 'Churn Reason',
    // },
    // churnComments: {
    //   systemFieldName: 'churnComments',
    //   name: 'churnComments',
    //   displayName: 'Churn Comments',
    // },
    // churnDate: {
    //   systemFieldName: 'churnDate',
    //   name: 'churnDate',
    //   displayName: 'Churn Date',
    // },
    domain: {
      systemFieldName: 'domain',
      name: 'domain',
      displayName: 'Domain',
    },
    nps: {
      systemFieldName: 'nps',
      name: 'nps',
      displayName: 'NPS',
    },
    csat: {
      systemFieldName: 'csat',
      name: 'csat',
      displayName: 'CSAT',
    },
  },
  [constants.ACCOUNT_LEVEL]: {
    about: {
      systemFieldName: 'about',
      name: 'about',
      displayName: 'About',
    },
    externalId: {
      systemFieldName: 'externalId',
      name: 'externalId',
      displayName: 'External ID',
    },
    pulse: {
      systemFieldName: 'pulse',
      name: 'pulse',
      displayName: 'Pulse',
    },
    primaryOwner: {
      systemFieldName: 'owners',
      name: 'primaryOwner',
      displayName: 'Primary Owner',
    },
    lifecycleStage: {
      systemFieldName: 'lifecycleStageId',
      name: 'lifecycleStage',
      displayName: 'Lifecycle Stage',
    },
    healthScore: {
      systemFieldName: 'healthScore',
      name: 'healthScore',
      displayName: 'Health Score',
    },
    healthStatus: {
      systemFieldName: 'healthStatus',
      name: 'healthStatus',
      displayName: 'Health Status',
    },
    // churnReason: {
    //   systemFieldName: 'churnReason',
    //   name: 'churnReason',
    //   displayName: 'Churn Reason',
    // },
    // churnComments: {
    //   systemFieldName: 'churnComments',
    //   name: 'churnComments',
    //   displayName: 'Churn Comments',
    // },
    // churnDate: {
    //   systemFieldName: 'churnDate',
    //   name: 'churnDate',
    //   displayName: 'Churn Date',
    // },
    domain: {
      systemFieldName: 'domain',
      name: 'domain',
      displayName: 'Domain',
    },
    nps: {
      systemFieldName: 'nps',
      name: 'nps',
      displayName: 'NPS',
    },
    csat: {
      systemFieldName: 'csat',
      name: 'csat',
      displayName: 'CSAT',
    },
    // parentOrganization: {
    //   systemFieldName: 'organizations',
    //   name: 'parentOrganization',
    //   displayName: 'Parent Organization',
    // },
  },
  [constants.CONTACT_LEVEL]: {
    about: {
      systemFieldName: 'about',
      name: 'about',
      displayName: 'About',
    },
    externalId: {
      systemFieldName: 'externalId',
      name: 'externalId',
      displayName: 'External ID',
    },
    lifecycleStage: {
      systemFieldName: 'lifecycleStageId',
      name: 'lifecycleStage',
      displayName: 'Lifecycle Stage',
    },
    healthScore: {
      systemFieldName: 'healthScore',
      name: 'healthScore',
      displayName: 'Health Score',
    },
    healthStatus: {
      systemFieldName: 'healthStatus',
      name: 'healthStatus',
      displayName: 'Health Status',
    },
    pulse: {
      systemFieldName: 'pulse',
      name: 'pulse',
      displayName: 'Pulse',
    },
    email: {
      systemFieldName: 'email',
      name: 'email',
      displayName: 'Email',
    },
    portalAccess: {
      systemFieldName: 'portalAccess',
      name: 'portalAccess',
      displayName: 'Portal Access',
    },
    lastNps: {
      systemFieldName: 'lastNps',
      name: 'lastNps',
      displayName: 'Last NPS Rating',
    },
    lastCsat: {
      systemFieldName: 'lastCsat',
      name: 'lastCsat',
      displayName: 'Last CSAT Rating',
    },
  },
};

export const CHURN_FIELDS_PAYLOAD_MAPPING = {
  [SYSTEM_FIELDS.CHURN_DATE]: 'date',
  [SYSTEM_FIELDS.CHURN_REASON]: 'reason',
  [SYSTEM_FIELDS.CHURN_COMMENT]: 'comments',
};

export const CHURN_REASONS_IDS = {
  FAILED_TO_ACHIEVE_OUTCOME: 1,
  LOST_CHAMPION: 2,
  LOW_ADOPTION: 3,
  POOR_SERVICE: 4,
  PRODUCT_ISSUE: 5,
  NOT_THE_IDEAL_CUSTOMER: 6,
  SWITCH_TO_COMPETITOR: 7,
  BUY_OVER: 8,
  OTHER: 999,
};

export const CHURN_REASON_ID_VALUE_MAPPING = {
  [CHURN_REASONS_IDS.FAILED_TO_ACHIEVE_OUTCOME]: 'Failed to Achieve Outcome',
  [CHURN_REASONS_IDS.LOST_CHAMPION]: 'Lost Champion',
  [CHURN_REASONS_IDS.LOW_ADOPTION]: 'Low Adoption',
  [CHURN_REASONS_IDS.POOR_SERVICE]: 'Poor Service',
  [CHURN_REASONS_IDS.PRODUCT_ISSUE]: 'Product Issue',
  [CHURN_REASONS_IDS.NOT_THE_IDEAL_CUSTOMER]: 'Not the ideal customer',
  [CHURN_REASONS_IDS.SWITCH_TO_COMPETITOR]: 'Switch to Competitor',
  [CHURN_REASONS_IDS.BUY_OVER]: 'Buy over',
  [CHURN_REASONS_IDS.OTHER]: 'Other',
};

export const DEFAULT_CHURN_REASON = CHURN_REASONS_IDS.FAILED_TO_ACHIEVE_OUTCOME;

export const MAX_DOMAINS_PER_ENTITY = 20;
export const MAX_DOMAIN_CHAR_COUNT = 150;
